import { render } from "./VerifyCustomerContact.vue?vue&type=template&id=53aed9ce"
import script from "./VerifyCustomerContact.vue?vue&type=script&lang=js"
export * from "./VerifyCustomerContact.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__